import React from "react";
import {Box, Stack} from "@mui/material";
import {Link as RouterLink} from "react-router-dom";
import {styles} from "../MetricsDetailsStyles";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import moduleStyles from "../Utilities/Styles.module.css"

export const MetricsDetailHeaderLabel = () => {
    return (
        <Stack direction={'column'} className={moduleStyles.headerLabelStack}>
            <Box sx={{display: 'flex', justifyContent: 'flex-start'}}>
                <RouterLink to='/support' className="tms-no-underline">
                    <Box sx={styles.backLink}>
                        <Box>
                            <ArrowBackIosNewIcon sx={styles.arrowBack}/>
                        </Box>
                        <Box className={moduleStyles.mt1}>Back to Support Metrics</Box>
                    </Box>
                </RouterLink>
            </Box>
        </Stack>
    )
}